<template>
  <div class="details-view">
    <div class="main-content accrueReportWeekly">
      <div class="section form-column" style="width: 1150px;">
        <el-form :inline="true" label-width="60px" label-position="right" style="margin-top: 5px;">
          <el-form-item label-width="100px" :label="'COPY DATE'">
            <el-select v-model="copyDate" no="copyDate" style="width: 140px;">
              <el-option v-for="(item,index) in copyDates" :key="index" :label="copyDateLabelFun(item)" :value="item" />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_BranchCMP')">
            <cargo-advance-select
              no="branchIds"
              :select-type="selectTypeNames.basic_data_Office"
              :multiple="true"
              :clearable="false"
              filterable
              :default-multiple-value="branchIds"
              tag-value="officeId"
              tag-name="code"
              :filter-tag-names="['englishName','chineseName','code']"
              :cache="false"
              :static-options="currentOfficeList"
              :placeholder="' '"
              style="width: 150px;"
              @parentCallBack="p=>{currentOfficeIdChange(p.value)}"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_Department')">
            <cargo-advance-select
              no="deptIds"
              :select-type="selectTypeNames.basic_data_Department"
              :multiple="true"
              filterable
              :default-multiple-value="deptIds"
              tag-value="departmentId"
              :tag-name="isZh ? 'chineseName' : 'englishName'"
              :filter-tag-names="['englishName','chineseName','code']"
              :cache="false"
              :static-options="currentDeptList"
              :placeholder="' '"
              style="width: 240px;"
              @parentCallBack="p=>{deptIds=p.value;}"
            />
          </el-form-item>
          <el-form-item style="margin-bottom: 15px!important;">
            <el-button no="dataExport" type="primary" @click="toDataExport()">{{ $t('CargoMsg.Cargo_DataExport') }}</el-button>
            <span style="font-size:13px;color:orange; margin-left: 25px;">{{ lastWeeklyDate }}</span>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import { exportAccrueReportWeekly } from '@/api/clearing/pillReport'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { cacheKeys, getFilterCacheList } from '@/utils/basicDataCache'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'

export default {
  name: 'TabAccrueReportWeekly',
  components: { cargoAdvanceSelect },
  props: {
    queryBranchList: { type: Array, default: () => [] },
    queryDeptIdList: { type: Array, default: () => [] },
    copyDateList: { type: Array, default: () => [] },
    latestWeeklyDate: { type: String, default: '' }
  },
  data() {
    return {
      loading: false,
      copyDate: '',
      selectTypeNames: TYPE_NAMES,
      currentDeptList: [], // 部门列表
      branchIds: [], // 分公司IDS
      deptIds: [] // 部门IDS
    }
  },
  computed: {
    copyDates() {
      return this.copyDateList || []
    },
    lastWeeklyDate() {
      return 'Last archive date ' + ColumnUtils.dateTimeLabelFunc(this.latestWeeklyDate)
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    // 分公司列表
    currentOfficeList() {
      if (this.queryBranchList && this.queryBranchList.length > 0) {
        return this.queryBranchList
      }
      return this.$store.state.user.userInfo.currentUserOfficeList
    }
  },
  created() {

  },
  methods: {
    copyDateLabelFun(data) {
      if (data) {
        return ColumnUtils.dateLabelFunc(data)
      }
      return data
    },
    toDataExport() {
      console.log('copyDate:', this.copyDate)
      if (!this.copyDate) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + ' COPY DATE')
        return
      }
      //
      this.loading = getLoading()
      exportAccrueReportWeekly({ 'copyDate': this.copyDate, 'branchIds': this.branchIds, 'deptIds': this.deptIds }).then(res => {
        if (res.ok) {
          const h = this.$createElement
          this.$msgbox({
            title: this.$t('common.tips.prompt'),
            message: h('p', null, [
              h('p', { style: 'font-size: 18px;padding-bottom:5px' }, this.$t('PillReport.ExportingData')),
              h('p', { style: 'color: red' }, this.$t('CargoMsg.Cargo_ImportingDataSuccess'))
            ]),
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            type: 'success'
          })
        } else {
          this.$confirm(res.message, this.$t('common.tips.prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            canCloseModule: true,
            type: 'warning'
          })
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    // 默认值
    setDefaultCondition() {
      if (this.copyDates.length > 0) {
        this.copyDate = this.copyDates[0]
      }
    },
    currentOfficeIdChange(val) {
      this.branchIds = val || []
      // 部门
      this.deptIds = []
      this.currentDeptList = []
      for (const branchId of this.branchIds) {
        const currentOffice = this.currentOfficeList.find(item => Number(item.officeId) === Number(branchId))
        const currentDeptList = getFilterCacheList(cacheKeys.basic_data_Department_All, (item) => {
          return item.officeUuid === currentOffice.uuid && (this.queryDeptIdList.length === 0 || this.queryDeptIdList.includes(item.departmentId))
        }) || []
        if (currentDeptList.length !== 0) {
          this.currentDeptList.push(...currentDeptList)
        }
      }
    }

  }
}
</script>

<style lang="scss">

</style>
